import React, { useState, useContext, useEffect } from 'react';
import '../agent_page.css'
import { AppContext } from '../../../provider'
import CancleSvg from '../../../assets/cancle.svg'
import { storeRequest, getServices, getServiceCategories } from '../../../controller/agent_data_controller';

export const SubmitRequest = () => {
    const [loading, setLoading] = useState(false);
    const { setSidebarIndex, p_getBalance } = useContext(AppContext);
    const [files, setMyFiles] = useState([]);
    const [services, setServices] = useState([]);
    const [categories, setCategories] = useState([]);
    const [type, setType] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [description, setDescription] = useState('');
    const [uploadLater, setUploadLater] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            const [servicesData, categoriesData] = await Promise.all([
                getServices(),
                getServiceCategories()
            ]);
            setServices(servicesData);
            setCategories(categoriesData.map(c => ({ id: c[0], name: c[1] })));
        };
        fetchData();
    }, []);

    function validateEmail(str) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(str.trim());
    }
    function isAlphabetWithSpace(str) {
        return /^[A-Za-z\s]+$/.test(str);
    }

    async function validate_request_data() {
        if (name === '' || email === '' || mobile === '') {
            alert('Fill mandatory data');
            return
        }
        if (!validateEmail(email)) {
            alert('Enter valid eamil ID');
            return
        }
        if (!isAlphabetWithSpace(name)) {
            alert('Enter valid name')
            return
        }
        if (mobile.length !== 10) {
            alert('Enter 10 digit mobile number');
            return
        }
        if (files.length === 0 && !uploadLater) {
            alert('Upload minimun 1 document or check "Upload remaining documents later"');
            return
        }

        // Find the price for the selected service
        const selectedService = services.find(s => s[1] === type);
        const price = selectedService ? parseInt(selectedService[2]) : 500;

        setLoading(true);
        const docStatus = uploadLater ? 'pending' : 'complete';
        const result = await storeRequest(type, name, email, mobile, description, files, price, docStatus)
        if (result === 'submitted') {
            clear();
            setSidebarIndex(2)
            p_getBalance();
        }
        setLoading(false);
    }

    function clear() {
        if (services.length > 0) {
            setType(services[0][1]);
        }
        setName('');
        setEmail('');
        setMobile('');
        setDescription('');
        setUploadLater(false);
        document.getElementById("MyFiles").value = "";
    }

    return <div>
        <p className='title-demo'>Create New Request</p>
        <div style={{ width: '100%', minHeight: '80%', display: 'flex', justifyContent: 'center' }}>
            <div className='content-div-demo'>
                <div style={{ marginTop: '57px', marginLeft: '28px' }}>
                    <p className='form-header-demo'>Customer Information</p>
                    <div className='input-div-demo'>
                        <span className='input-label-demo'>Name</span>
                        <input className='input-box-demo' type='text' value={name} onChange={(e) => { setName(e.target.value) }} />
                    </div>
                    <div className='input-div-demo'>
                        <span className='input-label-demo'>Email</span>
                        <input className='input-box-demo' type='text' value={email} onChange={(e) => { setEmail(e.target.value) }} />
                    </div>
                    <div className='input-div-demo'>
                        <span className='input-label-demo'>Phone</span>
                        <input className='input-box-demo' type='number' value={mobile} onChange={(e) => {
                            if (e.target.value.length <= 10) {
                                setMobile(e.target.value)
                            }
                        }} />
                    </div>
                    <div className='input-div-demo'>
                        <span className='input-label-demo'>Service Category</span>
                        <select
                            className='input-box-demo'
                            value={selectedCategory}
                            onChange={(e) => {
                                setSelectedCategory(e.target.value);
                                setType(''); // Reset service selection when category changes
                            }}
                        >
                            <option value="">Select Category</option>
                            <option value="all">All Categories</option>
                            {categories.map(cat => (
                                <option key={cat.id} value={cat.id}>{cat.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className='input-div-demo'>
                        <span className='input-label-demo'>Service</span>
                        <select className='input-box-demo' name="type" id="type" value={type} onChange={(e) => { setType(e.target.value) }}>
                            <option value="">Select Service</option>
                            {services
                                .filter(s => {
                                    if (!selectedCategory || selectedCategory === 'all') return true;
                                    return s[5] == selectedCategory;
                                })
                                .map(service => (
                                    <option key={service[0]} value={service[1]}>{service[1]}</option>
                                ))
                            }
                            {services.length === 0 && <option value="">Loading services...</option>}
                        </select>
                    </div>
                    {type && services.find(s => s[1] === type) && (
                        <div className='input-div-demo' style={{ height: 'auto', alignItems: 'flex-start' }}>
                            <span className='input-label-demo'>Required Documents</span>
                            <div style={{ width: '400px', paddingLeft: '20px', boxSizing: 'border-box' }}>
                                {(() => {
                                    const service = services.find(s => s[1] === type);
                                    let docs = [];
                                    try {
                                        docs = JSON.parse(service[3]);
                                    } catch (e) {
                                        docs = service[3] ? service[3].split(',').map(d => d.trim()).filter(d => d !== '') : [];
                                    }

                                    if (docs.length === 0) return <span style={{ color: '#888', fontStyle: 'italic', fontSize: '14px' }}>None</span>;

                                    return (
                                        <ol style={{ margin: 0, paddingLeft: '15px', color: '#555', fontSize: '14px' }}>
                                            {docs.map((doc, idx) => (
                                                <li key={idx} style={{ marginBottom: '5px' }}>{doc}</li>
                                            ))}
                                        </ol>
                                    );
                                })()}
                            </div>
                        </div>
                    )}
                    <div className='input-div-demo'>
                        <span className='input-label-demo' >Description</span>
                        <textarea className='input-box-demo' style={{ padding: '5px' }} name="description" id="description" value={description} onChange={(e) => { setDescription(e.target.value) }}></textarea>
                    </div>
                    <div className='input-div-demo' style={{ height: '50px' }}>
                        <span className='input-label-demo'>Upload Documents</span>
                        <div className='input-file-box-demo' style={{ border: 'none' }}>
                            <label
                                htmlFor="MyFiles"
                                style={{
                                    backgroundColor: "#007bff",
                                    color: "white",
                                    padding: "2px 16px",
                                    borderRadius: "8px",
                                    cursor: "pointer",
                                }}
                            >
                                Select File
                            </label>
                            <input
                                style={{ height: '25px', marginBottom: '5px', display: 'none' }}
                                onChange={(e) => {
                                    const maxFileLimit = 4
                                    const maxFileSize = 5 * 1024 * 1024;
                                    if (e.target.files.length > maxFileLimit) {
                                        alert('you can select maximun 4 files')
                                        document.getElementById("MyFiles").value = "";
                                        return
                                    } else {
                                        for (let file of e.target.files) {
                                            if (file.size > maxFileSize) {
                                                alert(`File "${file.name}" is too large. Max size is 5 MB.`);
                                                document.getElementById("MyFiles").value = "";
                                                return
                                            }
                                        }
                                        for (let file of e.target.files) {
                                            const isDuplicate = files.some(f => f.name === file.name && f.size === file.size);
                                            let newFilesCount = 0;
                                            if (!isDuplicate) {
                                                newFilesCount++;
                                                if (files.length + newFilesCount > maxFileLimit) {
                                                    alert('you can select maximun 4 files')
                                                    return
                                                }
                                                setMyFiles(prev => [...prev, file]);
                                            }
                                        }
                                        e.target.value = "";
                                    }
                                }} type="file" id='MyFiles' multiple />
                            <div style={{ display: 'flex', marginTop: '10px' }}>
                                {
                                    files.length === 0 ? <span>No file selected</span> :
                                        files.map((item, index) => (
                                            <div key={index} style={{ display: 'flex' }}>
                                                <div style={{ width: '70px', overflow: 'clip', height: '20px' }}>
                                                    {item.name}
                                                </div>
                                                <img
                                                    onClick={
                                                        () => {
                                                            setMyFiles(files => files.filter((_, i) => i !== index))
                                                        }
                                                    }
                                                    style={{ height: '20px', marginRight: '15px' }}
                                                    src={CancleSvg} alt="" />
                                            </div>
                                        ))}
                            </div>
                        </div>
                    </div>
                    <div className='input-div-demo' style={{ height: 'auto', marginTop: '-10px' }}>
                        <span className='input-label-demo'></span>
                        <div style={{ width: '400px', display: 'flex', alignItems: 'center' }}>
                            <input
                                type="checkbox"
                                id="uploadLater"
                                checked={uploadLater}
                                onChange={(e) => setUploadLater(e.target.checked)}
                                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                            />
                            <label htmlFor="uploadLater" style={{ marginLeft: '8px', fontSize: '14px', color: '#555', cursor: 'pointer' }}>
                                Upload remaining documents later
                            </label>
                        </div>
                    </div>
                    <div className='input-div-demo'>
                        <div className='submit-button' onClick={validate_request_data}>
                            {loading ? <div className='loader'></div> : <span>Submit</span>}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
}





